import React, { useEffect, useRef, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import Button from "../Components/Button";
import InputBoxTrans from "../Components/InputBoxTrans";
import LinkText from "../Components/LinkText";
import { ReactComponent as IconInfoRed } from "../Images/icon_info_red.svg";
import { ReactComponent as RMLogo } from "../Images/RM logo_blue.svg";
import Footer from "../Layout/Footer";
import PlanExpired from "../Modals/PlanExpired";
import "../Styles/global.css";
import { useGoToAddr } from "../Utils/navigationUtils.js";
import {
  clearDashboardSession,
  setDashboardSession,
} from "../Utils/sessionUtils.js";
import { showToast } from "../Utils/variables.js";

const Login = () => {
  const location = useLocation();
  const [planExpired, SetPlanExpired] = useState(false);

  const closeModal = () => {
    SetPlanExpired(false);
  };

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [responseCode, setResponseCode] = useState(200);
  const [error_message_email, setError_message_email] = useState("");
  const [error_message_password, setError_message_password] = useState("");
  const [loginFail_count, setLoginFail_count] = useState(0);

  const [tabPressed, setTabPressed] = useState(null);

  const [hasError, setHasError] = useState(false);

  const handleInput_email = (value, message) => {
    setEmail(value);
    setError_message_email(message);
  };

  const handleInput_password = (value, message) => {
    setPassword(value);
    setError_message_password(message);
  };

  const emailRef = useRef(null);
  const pwRef = useRef(null);
  const loginBtnRef = useRef(null);

  const handleTabKey = (id) => {
    if (id === 0) {
      setTabPressed(1);
      if (pwRef.current) pwRef.current.focus();
    } else if (id === 1) {
      setTabPressed(2);
      if (loginBtnRef.current) loginBtnRef.current.focus();
    } else if (id === null) {
      setTabPressed(null);
    }
  };

  const checkValueError = () => {
    let hasValidationError = false;

    if (!email) {
      setError_message_email("기업 이메일을 입력해주세요.");
      hasValidationError = true;
    } else {
      setError_message_email("");
    }

    if (!password) {
      setError_message_password("비밀번호를 입력해주세요.");
      hasValidationError = true;
    } else {
      setError_message_password("");
    }

    setHasError(hasValidationError);
    return hasValidationError;
  };

  const handleLogin = async () => {
    const hasValidationError = checkValueError();

    if (!hasValidationError) {
      clearDashboardSession();
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/dashboard/auth/logIn`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
              email: email,
              password: password,
            }),
          }
        );

        const data = await response.json();

        if (data.code === 200) {
          setResponseCode(200);

          const _data = data.data;
          setDashboardSession({
            accessToken: _data.accessToken,
            companyCode: _data.companyCode,
            companyId: _data.companyId,
            companyName: _data.companyName,
            companyNameEn: _data.companyNameEn,
            email: _data.email,
            passwordTime: _data.passwordTime,
            logo: _data.logo,
            logoVisibleType: _data.logoVisibleType,
            isEmailVisible: _data.isEmailVisible,
          });

          if (_data.companyName !== null) {
            goToAddr("home");
          } else {
            goToAddr("init_user");
          }
        } else if (data.code === 1001) {
          SetPlanExpired(true);
          setResponseCode(1001);
        } else if (data.code === 1002) {
          setError_message_email("파트너스 정보가 존재하지 않습니다.");
          setResponseCode(1002);
        } else if (data.code === 1003) {
          setLoginFail_count(loginFail_count + 1);
          setResponseCode(1003);

          if (loginFail_count >= 5) {
            setError_message_password(
              "로그인에 5회 이상 실패했습니다. 10회이상 실패하는 경우 비밀번호 재설정이 필요합니다."
            );
          } else {
            setError_message_password(
              "이메일 또는 비밀번호가 일치하지 않습니다. 입력한 정보를 확인해주세요."
            );
          }
        } else if (data.code === 1004) {
          setError_message_password(
            "로그인에 10회 이상 실패했습니다. 비밀번호를 재설정 해주세요."
          );
          setResponseCode(1004);
        }
      } catch (error) {
        console.error("로그인 중 에러: ", error);
      }
    }
  };

  const goToAddr = useGoToAddr();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.toast_enable) {
      showToast("비밀번호가 재설정되었습니다. 다시 로그인해주세요.", "success");
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div>
      {planExpired && <PlanExpired closeModal={closeModal} />}
      <TopLeftLogo
        href="https://web.rankingmarathon.com/"
        aria-label="랭킹마라톤 웹으로 이동"
      >
        <RMLogo />
      </TopLeftLogo>
      <div className="page-wrapper center">
        <div className="hrz-wrapper center"></div>
        <LoginBox>
          <div className="center">
            <p
              className="bold-text"
              style={{ fontSize: "30px", color: "#000000" }}
            >
              로그인
            </p>
          </div>

          <div className="center">
            <p style={{ marginTop: "10px", color: "#888888" }}>
              랭킹마라톤 건강관리 솔루션
            </p>
          </div>
          <div style={{ marginTop: "30px" }}>
            <InputBoxTrans
              message="기업 이메일 입력"
              handleInput={handleInput_email}
              code={responseCode}
              hasError={hasError}
              handleTabKey={handleTabKey}
              tabPressed={tabPressed}
              id={0}
              inputRef={emailRef}
            />
          </div>

          {error_message_email && (
            <div className="hrz-wrapper" style={{ marginTop: "6px" }}>
              <IconInfoRed />
              <p
                style={{
                  color: "#f25c5c",
                  fontSize: "14px",
                  marginLeft: "4px",
                }}
              >
                {error_message_email}
              </p>
            </div>
          )}
          <div style={{ marginTop: 10 }}>
            <InputBoxTrans
              message="비밀번호 입력"
              type="password"
              handleInput={handleInput_password}
              handleEnterKey={handleLogin}
              code={responseCode}
              loginFail_count={loginFail_count}
              hasError={hasError}
              handleTabKey={handleTabKey}
              tabPressed={tabPressed}
              id={1}
              inputRef={pwRef}
            />
          </div>

          {error_message_password && (
            <div className="hrz-wrapper" style={{ marginTop: "6px" }}>
              <IconInfoRed />
              <p
                style={{
                  color: "#f25c5c",
                  fontSize: "14px",
                  marginLeft: "4px",
                }}
              >
                {error_message_password}
              </p>
            </div>
          )}
          <div
            onClick={() => {
              handleLogin();
            }}
            style={{ marginTop: 30 }}
          >
            <Button
              message="로그인"
              handleTabKey={handleTabKey}
              tabPressed={tabPressed}
              id={2}
              inputRef={loginBtnRef}
              onClickEvent={handleLogin}
            />
          </div>
          <div
            onClick={() => navigate("/emailauth", { replace: true })}
            style={{ marginTop: 14 }}
          >
            <LinkText message="비밀번호를 잊으셨나요?" />
          </div>
          <Outlet />
        </LoginBox>
        <Footer />
      </div>
    </div>
  );
};

const TopLeftLogo = styled.a`
  position: fixed;
  top: 36px;
  left: 320px;
  z-index: 2;
  display: inline-flex;
  cursor: pointer;
  svg {
    width: 115px;
    height: auto;
  }
`;

const LoginBox = styled.div`
  width: 400px;
  height: auto;
  margin-top: 240px;
  margin-bottom: 140px;
  display: flex;
  flex-direction: column;
  font-family: "notoSans";
`;

export default Login;
